import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen bg-white text-[#111]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-zinc-200">
        <div className="max-w-5xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-3 group">
            <span className="w-9 h-9 bg-[#002FA7] text-white font-display text-sm flex items-center justify-center">
              BoT
            </span>
            <div className="leading-none hidden sm:block">
              <div className="font-display text-base tracking-tight">BoT Summit 2026</div>
              <div className="overline text-[10px] text-zinc-500 mt-0.5">Best of Tech</div>
            </div>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-btn"
            className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] uppercase border border-zinc-300 px-4 py-2 hover:bg-black hover:text-white hover:border-black transition-colors"
          >
            <ArrowLeft size={14} /> Back
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="overline text-[#FF2A00] mb-4">{eyebrow}</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase tracking-tighter">
          {title}
        </h1>
        {updated && (
          <div className="mt-6 overline text-zinc-500">Last updated: {updated}</div>
        )}
        <div className="mt-12 prose prose-zinc max-w-none legal-body">
          {children}
        </div>
      </main>

      <footer className="border-t border-zinc-200 mt-16">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="overline text-zinc-500">© 2026 BoT Summit · All rights reserved.</div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 overline text-zinc-500">
            <Link to="/sponsorship" className="hover:text-[#002FA7]">Sponsorship</Link>
            <Link to="/payment-terms" className="hover:text-[#002FA7]">Payment Terms</Link>
            <Link to="/code-of-conduct" className="hover:text-[#002FA7]">Code of Conduct</Link>
            <Link to="/privacy" className="hover:text-[#002FA7]">Privacy</Link>
            <Link to="/" className="hover:text-[#002FA7]">Home</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
